import { Pane } from "../../Box/Pane";
import { log2 } from "../../../../../HA";

export class EntryItem extends Pane {
    protected getModel() {
        const model = this.get("model");
        return this.replaceValues(model);
    }

    protected createSelf() {
        super.createSelf();
        const model = this.getModel();
        try {
            this.createByType(model, this);
        } catch (e) {
            log2(e);
            throw e;
        }
        this.addClass("ei");
    }
}
